import React from 'react';
import { Container } from './styles';
import TextInput, { TextInputProps } from './TextInput';
import IconPanel, { IconPanelProps } from './IconPanel';

export interface ChatFooterProps {
  textInput?: TextInputProps;
  iconsPanel?: IconPanelProps;
}

const ChatFooter: React.FC<ChatFooterProps> = () => {
  return (
    <Container as="sdiv">
      <TextInput />
      <IconPanel />
    </Container>
  );
}

export default ChatFooter;